// extracted by mini-css-extract-plugin
export default {"label_car":"CarCardHeader_label_car__R59Gb","left_part":"CarCardHeader_left_part__NYGCm","icon_sub_car":"CarCardHeader_icon_sub_car__ruu39"};